//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const AchievementType = {
    /** Ten Weeks in a row */
    TenWeeksInARow: "21E6CC63-702B-4A5D-BC92-503B0F5CAF5D",
    /** Twenty Weeks in a Year */
    TwentyWeeksInAYear: "67EA551D-C3A6-4339-9F39-F6F4E4DAB4EA",
};
